import React from 'react'

function Footer() {
  return (
    <div className="w-[100%] h-[80px] flex justify-center items-center bg-white">
    <span className="text-[14px] text-[#1C3F79]">
      &copy; Copyright<b> AAHDAB.</b> All Right Reserved.
    </span>
  </div>
  )
}

export default Footer